import React, { useContext } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import EnvironmentContext from '../../../contexts/EnvironmentContext';
import { Divider, Card, EmptyState } from '@hz-design-system/web-ui';

import UserReviewsHeader from './UserReviewsHeader';
import UserReviewsRatingBreakdown from './UserReviewsRatingBreakdown';
import UserReviewsCharacteristics from './UserReviewsCharacteristics';
import UserReviewsList from './UserReviewsList';

import Classes from './UserReviewsComponent.scss';

const WrapperConponent = ({ isMyReviews, children }: { isMyReviews: boolean; children: React.ReactNode }) =>
  isMyReviews ? (
    <Card padding="s" className="u-marginTopM">
      {children}
    </Card>
  ) : (
    <>{children}</>
  );

const UserReviewsComponent = () => {
  const { reviewee, summary, reviews = [], isMyReviews = false } = useContext(EnvironmentContext);
  const { t } = useI18nContext();

  const hasReviews = summary?.numberOfReviews && summary.numberOfReviews > 0;
  const hasCharacteristics = !!summary?.characteristics.positive?.length || !!summary?.characteristics.negative?.length;

  if (!hasReviews) {
    return (
      <WrapperConponent isMyReviews={isMyReviews}>
        <div className={Classes.root}>
          <div className={Classes.emptyStateWrapper}>
            <EmptyState title={t('userReviews.empty.title')} icon="review" />
          </div>
        </div>
      </WrapperConponent>
    );
  }

  return (
    <WrapperConponent isMyReviews={isMyReviews}>
      <div className={Classes.root}>
        <UserReviewsHeader
          name={reviewee?.nickname ?? ''}
          numberOfReviews={summary?.numberOfReviews ?? 0}
          rating={summary?.averageScore ?? 0}
          activeSinceDiff={reviewee?.activeSinceDiff}
        />

        <Divider className={Classes.headerDivider} />

        {summary?.scores && summary.scores.length > 0 && (
          <UserReviewsRatingBreakdown ratings={summary.scores} className={Classes.ratingBreakdownBlock} />
        )}

        {hasCharacteristics && (
          <div>
            {summary?.characteristics.positive && summary.characteristics.positive.length > 0 && (
              <UserReviewsCharacteristics
                title={t('userReviews.characteristics.positive.title')}
                iconName="thumbsup"
                characteristics={summary.characteristics.positive}
                className={Classes.characteristicsBlock}
              />
            )}
            {summary?.characteristics.negative && summary.characteristics.negative.length > 0 && (
              <UserReviewsCharacteristics
                title={t('userReviews.characteristics.negative.title')}
                iconName="thumbsdown"
                characteristics={summary.characteristics.negative}
                className={Classes.characteristicsBlock}
              />
            )}
          </div>
        )}

        {reviews.length > 0 && <UserReviewsList reviews={reviews} />}
      </div>
    </WrapperConponent>
  );
};

export default UserReviewsComponent;
